module.exports = __webpack_public_path__ + "static/netlify-logo-ed21271fa91b30daf7875f3bfd8bf3a4.svg";